export enum ConfiguratorLevels {
    Level1 = "Level 1",
    Level2 = "Level 2"
}